import { render, staticRenderFns } from "./SettingPage.vue?vue&type=template&id=083c0ced&scoped=true&"
import script from "./SettingPage.vue?vue&type=script&lang=js&"
export * from "./SettingPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingPage.vue?vue&type=style&index=0&id=083c0ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c0ced",
  null
  
)

export default component.exports